export default __webpack_public_path__ + "static/media/icon-paypal-full.b2a3f81a.png";